import { render, staticRenderFns } from "./guideRate.vue?vue&type=template&id=bece0b42&"
import script from "./guideRate.vue?vue&type=script&lang=js&"
export * from "./guideRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports